import withResponsive from '../hoc/withResponsive'
import anime from 'animejs'
/**
 * Mock feature implementing most of the stuff on the stack.
 * Due to the 'withResponsive' HOC, foo will only mount on the requested breakpoints.
 *
 * Props:
 * shouldBar(boolean, optional): flag for toggling Bar
 * screens(object, optional): Used by withResponsive. object that can contains a 'min' and a 'max'
 * attribute. The breakpoints are specified in the withResponsive HOC.
 */
export default withResponsive({
  name: 'accordion',
  animation: {
    speed: 600,
    ease: 'easeOutSine',
  },

  ui: {
    'togglers[]': '[js-accordion-toggler]',
    'contents[]': '[js-accordion-content]',
  },

  events: [
    {
      target: 'togglers',
      on: 'click',
      handle (e) {
        this.clickToggler(e.currentTarget)
      },
    },
  ],

  componentDidMount () {
    // console.log(this.props.device)
    this.getContentsHeight()
    window.addEventListener('resize', this.getContentsHeight())

    // default opening if props is specified
    if (this.props && this.props.isOpened && this.props.isOpened === true) {
      this.ui.togglers[0].click()
    }
  },

  componentWillUnmount () {},

  clickToggler (togglerClicked) {
    const relContent = togglerClicked.parentNode.querySelector(
      '[js-accordion-content]'
    )
    const relContentH = relContent.getAttribute('data-h') + 'px'

    if (togglerClicked.classList.contains('is-active')) {
      togglerClicked.classList.remove('is-active')
      // relContent.classList.remove('is-active')
      anime({
        targets: relContent,
        height: [relContentH, '0px'],
        easing: this.animation.ease,
        duration: this.animation.speed,
      })
    } else {
      this.ui.togglers.forEach(el => {
        if (el.classList.contains('is-active')) {
          el.classList.remove('is-active')
          anime({
            targets: el.parentNode.querySelector('[js-accordion-content]'),
            height: [relContentH, '0px'],
            easing: this.animation.ease,
            duration: this.animation.speed,
          })
        }
      })
      /* this.ui.contents.forEach(el => {
        // el.classList.remove('is-active')
        anime({
          targets: el,
          height: [relContentH, '0px'],
          easing: this.animation.ease,
          duration: this.animation.speed,
        })
      }) */

      togglerClicked.classList.add('is-active')

      // relContent.classList.add('is-active')
      anime({
        targets: relContent,
        height: [0, relContentH],
        easing: this.animation.ease,
        duration: this.animation.speed,
      })
    }
  },

  getContentsHeight () {
    // commented because of IE11 mess
    /* for (const content of this.ui.contents) {
      content.classList.add('is-hidden')
      content.setAttribute('data-h', content.offsetHeight)
      content.classList.remove('is-hidden')
    } */
    Array.prototype.forEach.call(this.ui.contents, content => {
      content.classList.add('is-hidden')
      content.setAttribute('data-h', content.offsetHeight)
      content.classList.remove('is-hidden')
    })
  },
})
